module.exports = __webpack_public_path__ + "img/logo-gray.c5d1df8f.svg";